import {gsap} from "../../lib/gsap";

export default class BlockTextLetter {
	static init() {

		let blocks = document.querySelectorAll('.block-text-letter');

		blocks.forEach((block) => {
			let letters = block.querySelectorAll('.letter');

			// Initialisation de chaque lettre à une position décalée et une opacité nulle
			gsap.set(letters, {
				xPercent: 50,
				opacity: 0
			});

			// Création d'une timeline GSAP avec répétition infinie et sans délai entre les répétitions
			const tlEnter = gsap.timeline({
				repeat: -1,
				repeatDelay: 0
			});

			// Ajout d'une animation pour faire apparaître les lettres en séquence
			tlEnter.to(letters, {
				xPercent: 0,
				opacity: 1,
				duration: 0.8,
				ease: "power1.out",
				stagger: {
					each: 1.1, // Décalage de 0.1 seconde entre le début de chaque animation de lettre
					from: "start" // Commence l'animation depuis la première lettre
				}
			})
			// Ajout d'une animation pour faire disparaître les lettres en séquence
			.to(letters, {
				xPercent: -50,
				opacity: 0,
				duration: 0.6,
				ease: "power1.in",
				stagger: {
					each: 1.1,
					from: "start"
				}
			}, "1.1"); // Délai de 0.5 seconde après la fin de l'animation précédente avant de commencer celle-ci
		});

	}
}
